import { Component } from '@angular/core';
import { CUSTOM_ICONS, CustomIconDefinition } from './custom-icons.config';

/**
 * Component that provides custom SVG icon definitions for icons not included in the styleguide.
 * Icons are configured in custom-icons.config.ts
 */
@Component({
	standalone: false,
	selector: 'ss-custom-svg-definitions',
	templateUrl: './custom-svg-definitions.component.html',
	styleUrls: ['./custom-svg-definitions.component.scss'],
})
export class CustomSvgDefinitionsComponent {
	readonly icons: CustomIconDefinition[] = CUSTOM_ICONS;
}
